/**
 * Popular personal email domains
 * @see https://github.com/mailcheck/mailcheck/wiki/List-of-Popular-Domains
 */
export const PERSONAL_EMAIL_DOMAINS = new Set([
  /* Default domains included */
  'aol.com',
  'att.net',
  'comcast.net',
  'gmail.com',
  'gmx.com',
  'googlemail.com',
  'hotmail.com',
  'hotmail.co.uk',
  'hotmail.co.jp',
  'mac.com',
  'me.com',
  'mail.com',
  'msn.com',
  'live.com',
  'sbcglobal.net',
  'verizon.net',
  'yahoo.com',
  'yahoo.co.uk',
  'myyahoo.com',
  'windowslive.com',
  'yaho.com',
  'hey.com',
  'duck.com',

  /* Other global domains */
  'email.com',
  'fastmail.fm',
  'games.com' /* AOL */,
  'gmx.net',
  'hush.com',
  'hushmail.com',
  'icloud.com',
  'iname.com',
  'inbox.com',
  'lavabit.com',
  'love.com' /* AOL */,
  'outlook.com',
  'pobox.com',
  'protonmail.ch',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'tutanota.de',
  'tutanota.com',
  'tutamail.com',
  'tuta.io',
  'keemail.me',
  'rocketmail.com' /* Yahoo */,
  'safe-mail.net',
  'wow.com' /* AOL */,
  'ygm.com' /* AOL */,
  'ymail.com' /* Yahoo */,
  'zoho.com',
  'yandex.com',
  'fastmail.com',
  'zohomail.com',
  'aol.co.uk',
  'skiff.com',

  /* Privacy-focused email providers */
  'tuta.com',
  'mailbox.org',
  'posteo.de',
  'posteo.net',
  'startmail.com',
  'mailfence.com',
  'disroot.org',
  'vivaldi.net',
  'runbox.com',
  'countermail.com',

  /* United States ISP domains */
  'bellsouth.net',
  'charter.net',
  'cox.net',
  'earthlink.net',
  'juno.com',
  'centurylink.net',
  'frontiernet.net',
  'windstream.net',
  'optimum.net',
  'optonline.net',
  'suddenlink.net',
  'roadrunner.com',
  'netzero.net',
  'netzero.com',
  'mindspring.com',
  'embarqmail.com',
  'peoplepc.com',
  'excite.com',
  'lycos.com',
  'usa.net',
  'aim.com',

  /* British ISP domains */
  'btinternet.com',
  'virginmedia.com',
  'blueyonder.co.uk',
  'freeserve.co.uk',
  'live.co.uk',
  'ntlworld.com',
  'o2.co.uk',
  'orange.net',
  'sky.com',
  'talktalk.co.uk',
  'tiscali.co.uk',
  'virgin.net',
  'wanadoo.co.uk',
  'bt.com',

  /* Domains used in Asia */
  'sina.com',
  'sina.cn',
  'qq.com',
  'naver.com',
  'hanmail.net',
  'daum.net',
  'nate.com',
  'yahoo.co.jp',
  'yahoo.co.kr',
  'yahoo.co.id',
  'yahoo.co.in',
  'yahoo.com.sg',
  'yahoo.com.ph',
  '163.com',
  'yeah.net',
  '126.com',
  '21cn.com',
  'aliyun.com',
  'foxmail.com',
  'rediffmail.com',
  'docomo.ne.jp',
  'ezweb.ne.jp',
  'i.softbank.jp',
  'yahoo.com.tw',
  'yahoo.com.hk',

  /* French ISP domains */
  'hotmail.fr',
  'live.fr',
  'laposte.net',
  'yahoo.fr',
  'wanadoo.fr',
  'orange.fr',
  'gmx.fr',
  'sfr.fr',
  'neuf.fr',
  'free.fr',
  'outlook.fr',

  /* German ISP domains */
  'gmx.de',
  'hotmail.de',
  'live.de',
  'online.de',
  't-online.de' /* T-Mobile */,
  'web.de',
  'yahoo.de',
  'outlook.de',

  /* Italian ISP domains */
  'libero.it',
  'virgilio.it',
  'hotmail.it',
  'aol.it',
  'tiscali.it',
  'alice.it',
  'live.it',
  'yahoo.it',
  'email.it',
  'tin.it',
  'poste.it',
  'teletu.it',
  'outlook.it',

  /* Russian ISP domains */
  'mail.ru',
  'rambler.ru',
  'yandex.ru',
  'ya.ru',
  'list.ru',

  /* Belgian ISP domains */
  'hotmail.be',
  'live.be',
  'skynet.be',
  'voo.be',
  'tvcablenet.be',
  'telenet.be',

  /* Argentinian ISP domains */
  'hotmail.com.ar',
  'live.com.ar',
  'yahoo.com.ar',
  'fibertel.com.ar',
  'speedy.com.ar',
  'arnet.com.ar',

  /* Domains used in Mexico */
  'yahoo.com.mx',
  'live.com.mx',
  'hotmail.es',
  'hotmail.com.mx',
  'prodigy.net.mx',

  /* Domains used in Canada */
  'yahoo.ca',
  'hotmail.ca',
  'bell.net',
  'shaw.ca',
  'sympatico.ca',
  'rogers.com',

  /* Domains used in Brazil */
  'yahoo.com.br',
  'hotmail.com.br',
  'outlook.com.br',
  'uol.com.br',
  'bol.com.br',
  'terra.com.br',
  'ig.com.br',
  'itelefonica.com.br',
  'r7.com',
  'zipmail.com.br',
  'globo.com',
  'globomail.com',
  'oi.com.br',

  /* Domains used in Australia */
  'bigpond.com',
  'bigpond.net.au',
  'optusnet.com.au',
  'iinet.net.au',
  'dodo.com.au',
  'yahoo.com.au',
  'outlook.com.au',

  /* Domains used in New Zealand */
  'xtra.co.nz',
  'yahoo.co.nz',
  'outlook.co.nz',

  /* Dutch ISP domains */
  'ziggo.nl',
  'kpnmail.nl',
  'xs4all.nl',
  'hetnet.nl',
  'home.nl',
  'planet.nl',
  'upcmail.nl',
  'chello.nl',

  /* Spanish ISP domains */
  'yahoo.es',
  'outlook.es',
  'telefonica.net',
  'terra.es',

  /* Polish ISP domains */
  'wp.pl',
  'onet.pl',
  'interia.pl',
  'o2.pl',
  'poczta.fm',

  /* Czech ISP domains */
  'seznam.cz',
  'centrum.cz',
  'volny.cz',

  /* Turkish ISP domains */
  'mynet.com',

  /* South African ISP domains */
  'mweb.co.za',
  'webmail.co.za',
  'telkomsa.net',

  /* Portugal */
  'outlook.pt',
]);

/**
 * True when the email's domain is in {@link PERSONAL_EMAIL_DOMAINS}
 * (e.g. gmail.com, outlook.com). Used client-side to require a work email.
 */
export function isPersonalEmail(email: string): boolean {
  const domain = email.split('@').at(-1);
  if (!domain) {
    return false;
  }
  return PERSONAL_EMAIL_DOMAINS.has(domain.trim().toLowerCase());
}
